import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=669c731f&scoped=true&"
import script from "./confirm-email.vue?vue&type=script&lang=js&"
export * from "./confirm-email.vue?vue&type=script&lang=js&"
import style0 from "./confirm-email.vue?vue&type=style&index=0&id=669c731f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c731f",
  null
  
)

export default component.exports